import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaymentsApi } from "../api/payment.api";

@Injectable()
export class PaymentService {
  
  constructor(private api: PaymentsApi) {}

  removeAutomatedTopUp(): Observable<any> {
    return this.api.removeAutomatedTopUp();
  }

  getAutomatedTopUp(): Observable<any> {
    return this.api.getAutomatedTopUp();
  }

  getPayments(startDate: Date, endDate: Date): Observable<any> {
    return this.api.getPayments(startDate, endDate);
  }

  topUp(topup: any): Observable<any> {
    return this.api.topUp(topup);
  }

  getIntentStatus(intentId: string): Observable<any> {
    return this.api.getIntentStatus(intentId);
  }

  getPaymentCards(): Observable<any> {
    return this.api.getPaymentCards();
  }

  removePaymentCard(cardId: number): Observable<any> {
    return this.api.removePaymentCard(cardId);
  }

  getPaymentCard(cardId: number): Observable<any> {
    return this.api.getPaymentCard(cardId);
  }

  addCard(card: any): Observable<any> {
    return this.api.addCard(card);
  }

  updatePaymentCard(request: any): Observable<any> {
    return this.api.updatePaymentCard(request);
  }

  exportPayments(startDate: Date, endDate: Date): any {
    return this.api.exportPayments(startDate, endDate);
  }

  calculateNetAndVat(grossAmount): Observable<any> {
    return this.api.calculateNetAndVat(grossAmount);
  }

  downloadReceipt(receiptId: number): any {
    return this.api.downloadReceipt(
      receiptId,
      sessionStorage.getItem("seller_code")
    );
  }
}
